const NaturalSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      aria-hidden="true"
      focusable="false"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_101_385"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.947266" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_101_385)">
        <path
          d="M12.0033 21.9473C10.7587 21.9473 9.58867 21.7111 8.493 21.2388C7.3975 20.7664 6.4445 20.1254 5.634 19.3158C4.8235 18.5061 4.18192 17.5539 3.70925 16.4593C3.23642 15.3648 3 14.1952 3 12.9505C3 11.706 3.23625 10.5359 3.70875 9.44027C4.18125 8.34477 4.8225 7.39177 5.6325 6.58127C6.4425 5.77077 7.395 5.12918 8.49 4.65652C9.585 4.18368 10.755 3.94727 12 3.94727C13.0235 3.94727 13.9918 4.1056 14.905 4.42227C15.8183 4.73893 16.6513 5.1806 17.4038 5.74727L16.6845 6.49152C16.0257 6.00168 15.3008 5.62185 14.51 5.35202C13.7193 5.08218 12.8827 4.94727 12 4.94727C9.78333 4.94727 7.89583 5.72643 6.3375 7.28477C4.77917 8.8431 4 10.7306 4 12.9473C4 15.1639 4.77917 17.0514 6.3375 18.6098C7.89583 20.1681 9.78333 20.9473 12 20.9473C14.2167 20.9473 16.1042 20.1681 17.6625 18.6098C19.2208 17.0514 20 15.1639 20 12.9473C20 12.5448 19.9705 12.1499 19.9115 11.7628C19.8525 11.3758 19.7641 10.9994 19.6462 10.6338L20.4443 9.81652C20.6276 10.3113 20.766 10.8191 20.8595 11.3398C20.9532 11.8603 21 12.3961 21 12.9473C21 14.1923 20.7638 15.3623 20.2915 16.4573C19.8192 17.5523 19.1782 18.5048 18.3685 19.3148C17.5588 20.1248 16.6067 20.766 15.512 21.2385C14.4175 21.711 13.2479 21.9473 12.0033 21.9473ZM10.5615 16.855L7.00375 13.2973L7.7115 12.5895L10.5615 15.4395L20.2922 5.70302L21 6.41077L10.5615 16.855Z"
          fill="#006633"
        />
      </g>
    </svg>
  );
};

export default NaturalSVG;
